import { styled } from '@linaria/react';

export const ConversationInputContainer = styled.div`
	display: grid;
	width: 100%;
	min-width: 0;
	padding: 20px;
	margin-top: auto;
	column-gap: var(--base-gap);
	grid-area: input;
	grid-template-areas: 'input btn' 'topics topics' 'model model';
	grid-template-columns: minmax(0, 1fr) auto;
	grid-template-rows: auto 1fr auto;
`;

export const BotModelsArea = styled.div`
	margin: 20px auto 0;
	grid-area: model;

	&:empty {
		display: none;
	}
`;
